import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaUser,
  FaClinicMedical,
  FaChartBar,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaClipboardList,
  FaVideo,
  FaBars,
} from 'react-icons/fa';
import Logo from '../../assets/logo.svg';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import ServiceMenu from '../serviceMenu/ServiceMenu';
import './NavBar.css';

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isServiceMenuOpen, setServiceMenuOpen] = useState(false);
  const [userPlan, setUserPlan] = useState('Gratuito');
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleServiceMenu = () => {
    setServiceMenuOpen(!isServiceMenuOpen);
  };

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserPlan(userDoc.data().plano);
        }
      }
    };
    fetchUserPlan();
  }, [user, db]);

  const isRouteDisabled = (route) => {
    if (
      userPlan === 'Gratuito' &&
      (route === 'clinicas' ||
        route === 'relatorios' ||
        route === 'recebiveis' ||
        route === 'telemedicina')
    ) {
      return true;
    }
    if (
      userPlan === 'Premium' &&
      (route === 'relatorios' || route === 'telemedicina')
    ) {
      return true;
    }
    return false;
  };

  return (
    <nav className="navbar">
      <a href="/" className="logo" aria-label="Plantão Fácil - Home">
        <img src={Logo} alt="Plantão Fácil Logo" />
        Plantão Fácil
      </a>
      <button
        type="button"
        className={`hamburger ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
        aria-controls="navigation-menu"
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>
      <ul
        id="navigation-menu"
        className={`nav-links ${isOpen ? 'open' : ''}`}
        role="menu"
      >
        <li role="none">
          <button
            onClick={toggleServiceMenu}
            className="menu-icon-button"
            aria-label="Abrir menu de serviços"
            tabIndex={isOpen ? 0 : -1}
          >
            <FaBars size={20} />
          </button>
        </li>
        <li role="none">
          <NavLink
            to="/"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            className="nav-link"
          >
            <FaTachometerAlt size={20} /> Início
          </NavLink>
        </li>
        <li role="none">
          <NavLink
            to="/atendimento"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            className="nav-link"
          >
            <FaClipboardList size={20} /> Atendimento
          </NavLink>
          <ul className="submenu">
            <li role="none">
              <NavLink
                to="/atendimento/consultorio"
                onClick={toggleMenu}
                role="menuitem"
                tabIndex={isOpen ? 0 : -1}
                className="submenu-link"
              >
                <FaClinicMedical size={20} /> Consultório
              </NavLink>
            </li>
            <li role="none">
              <NavLink
                to="/atendimento/telemedicina"
                onClick={toggleMenu}
                role="menuitem"
                tabIndex={isOpen ? 0 : -1}
                aria-disabled={isRouteDisabled('telemedicina')}
                className={`submenu-link ${
                  isRouteDisabled('telemedicina') ? 'disabled' : ''
                }`}
                style={
                  isRouteDisabled('telemedicina')
                    ? { pointerEvents: 'none', opacity: 0.5 }
                    : {}
                }
              >
                <FaVideo size={20} /> Telemedicina
              </NavLink>
            </li>
          </ul>
        </li>
        <li role="none">
          <NavLink
            to="/pacientes"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            className="nav-link"
          >
            <FaUser size={20} /> Pacientes
          </NavLink>
        </li>
        <li role="none">
          <NavLink
            to="/clinicas"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            aria-disabled={isRouteDisabled('clinicas')}
            className={`nav-link ${
              isRouteDisabled('clinicas') ? 'disabled' : ''
            }`}
            style={
              isRouteDisabled('clinicas')
                ? { pointerEvents: 'none', opacity: 0.5 }
                : {}
            }
          >
            <FaClinicMedical size={20} /> Clínicas
          </NavLink>
        </li>
        <li role="none">
          <NavLink
            to="/agenda"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            className="nav-link"
          >
            <FaCalendarAlt size={20} /> Agenda
          </NavLink>
        </li>
        <li role="none">
          <NavLink
            to="/relatorios"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            aria-disabled={isRouteDisabled('relatorios')}
            className={`nav-link ${
              isRouteDisabled('relatorios') ? 'disabled' : ''
            }`}
            style={
              isRouteDisabled('relatorios')
                ? { pointerEvents: 'none', opacity: 0.5 }
                : {}
            }
          >
            <FaChartBar size={20} /> Relatórios
          </NavLink>
        </li>
        <li role="none">
          <NavLink
            to="/recebiveis"
            onClick={toggleMenu}
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
            aria-disabled={isRouteDisabled('recebiveis')}
            className={`nav-link ${
              isRouteDisabled('recebiveis') ? 'disabled' : ''
            }`}
            style={
              isRouteDisabled('recebiveis')
                ? { pointerEvents: 'none', opacity: 0.5 }
                : {}
            }
          >
            <FaMoneyBillWave size={20} /> Recebíveis
          </NavLink>
        </li>
      </ul>
      <ServiceMenu visible={isServiceMenuOpen} onClose={toggleServiceMenu} />
    </nav>
  );
}

export default NavBar;
